<template>
    <div id="step-4" class="step step-4" :class="{active: activeStep == 4}">

        <div class="line"></div>
        <div class="number">{{ step }}</div>
        <div class="title">{{ title }}</div>

        <mu-paper class="alert-balance on-step4" :z-depth="1" v-if="getBalanceByService < getTotalContacts() && isCompanyPrepaid && activeStep == 4">
            <div class="alert-content">
                <div class="icon-alert">
                    <font-awesome-icon icon="exclamation-triangle" class="icon-big-extra color-yellow"/>
                </div>
                <div class="text-alert">
                    <span>Atenção</span>
                    <p>Você selecionou o tipo de mensagem <b>"{{ getTypeMessage() }}"</b> e você possui apenas {{ getBalanceByService }} créditos para esse serviço e está campanha possui {{ getTotalContacts() }} contatos. Esteja ciente de que só parte das mensagens serão enviadas.</p>
                </div>
            </div>
        </mu-paper>

        <mu-paper class="content" :z-depth="1">

            <mu-row justify-content="start" align-items="center">
                <mu-col span="12" sm="12" md="3" lg="3" xl="3">
                    <div class="item-icon">
                        <font-awesome-icon :icon="(form.send == 'now' ? 'clock' : 'calendar-day')" class="icon-md"/>
                        <div class="text-normal">{{ form.send == 'now' ? 'Enviar' : 'Agendado para' }}</div>
                        <div class="text-detach">
                            <div v-if="form.send == 'now'">Agora</div>
                            <div v-if="form.send == 'schedule'">{{ dateMount(form.schedule.date) }} {{ dateMount(form.schedule.time, true) }}</div>
                        </div>
                    </div>
                    <div class="item-icon">
                        <font-awesome-icon icon="clone" class="icon-md"/>
                        <div class="text-normal">Tipo</div>
                        <div class="text-detach">{{ getTypeMessage() }}</div>
                    </div>
                </mu-col>
                <mu-col span="12" sm="12" md="3" lg="3" xl="3">
                    <div class="item-icon">
                        <font-awesome-icon icon="user-friends" class="icon-md"/>
                        <div class="text-normal">Contatos</div>
                        <div class="text-detach">{{ getTotalContacts() }}</div>
                    </div>
                    <div class="item-icon">
                        <font-awesome-icon icon="dollar-sign" class="icon-md"/>
                        <div class="text-normal">Valor Campanha</div>
                        <div class="text-detach">{{ getCoast() }}</div>
                    </div>
                </mu-col>
                <mu-col span="12" sm="12" md="6" lg="6" xl="6">
                    <div class="item-text">
                        <div class="title">Campanha</div>
                        <div class="description">{{ form.title }}</div>
                    </div>
                    <div class="item-text">
                        <div class="title">Mensagem</div>
                        <div class="description message background">
                            <div v-if="form.selected_type == 'new_message'">{{ form.message }}</div>
                            <div v-if="form.selected_type == 'default_message'">{{ form.default_message_description }}</div>
                        </div>
                        <div v-if="countChars(form.selected_type == 'new_message' ? form.message : form.default_message_description) > 160" class="alert-limit-characters">
                            <font-awesome-icon icon="exclamation-triangle" /> A mensagem contém mais de 160 caracteres. {{ countCredits(form.selected_type === 'new_message' ? form.message : form.default_message_description) }} créditos serão consumidos para cada contato.
                        </div>
                    </div>
                </mu-col>
            </mu-row>

            <template v-if="form.groups.length > 0">
                <br>
                <mu-divider></mu-divider>
                <br>

                <div class="item-text">
                    <div class="title">Grupos</div>
                    <div class="description -background">
                        <span v-for="(item, key) in form.groups" :key="key"><u>{{ item.name }}</u></span>
                    </div>
                </div>
            </template>

        </mu-paper>

        <mu-paper class="buttons" :z-depth="1">

            <mu-paper class="alert-balance alert-error on-step4" :z-depth="1" v-if="alertConference">
                <div class="alert-content">
                    <div class="icon-alert">
                        <font-awesome-icon icon="exclamation-triangle" class="icon-big-extra color-red"/>
                    </div>
                    <div class="text-alert">
                        <span>Atenção</span>
                        <p>Ocorreu um problema ao tentar confirmar sua campanha. <b>Antes de clicar novamente verifique se a campanha já foi criada para não ter duplicidade</b> ou entre em contate com o suporte!</p>
                    </div>
                </div>
            </mu-paper>

            <mu-flex justify-content="center" align-items="center">
                <mu-button color="#EEF1F3" textColor="#666" round @click="handlePrev()">
                     <font-awesome-icon icon="chevron-left" class="icon-md icon-margin-left"/>
                    Voltar
                </mu-button>
                <mu-button round @click="saveForm" color="primary">
                    <font-awesome-icon icon="check" class="icon-md icon-margin-left"/>
                    Confirmar
                </mu-button>
            </mu-flex>

        </mu-paper>

    </div>
</template>

<script>
    import moment from 'moment'
    import ChannelsServices from '@/services/settings/channels-clients'
    import CampaignsServices from '@/services/services/sms'
    import BalanceServices from '@/services/dashboards/balance'

    export default {
        name: 'campaign-step-contacts',
        props: ['activeStep', 'step', 'title', 'form'],

        // ╔╦╗╔═╗╔╦╗╔═╗
        //  ║║╠═╣ ║ ╠═╣
        // ═╩╝╩ ╩ ╩ ╩ ╩

        data () {
            return {
                options: {
                    channels: []
                },
                totalcontacts: 0,
                balances: {
                    loading: false,
                    list: []
                },
                alertConference: false
            }
        },

        // ╔═╗╔═╗╔╦╗╔═╗╦ ╦╔╦╗╔═╗╔╦╗
        // ║  ║ ║║║║╠═╝║ ║ ║ ║╣  ║║
        // ╚═╝╚═╝╩ ╩╩  ╚═╝ ╩ ╚═╝═╩╝

        computed: {
            /**
             * Encontrando o serviço selecionado e retornando o saldo dele
             */
            getBalanceByService () {
                let find = this.balances.list.find((item) => {
                    return item.service_id === this.form.type_message
                })
                return find ? find.balance : 0
            },

            /**
             * Trás os dados da empresa gravadas no state
             */
            isCompanyPrepaid () {
                return this.$store.state.company.signatureType === 'P' || this.$store.state.company.signatureType === 'T'
            }
        },

        // ╔╦╗╔═╗╦ ╦╔╗╔╔╦╗╔═╗╔╦╗
        // ║║║║ ║║ ║║║║ ║ ║╣  ║║
        // ╩ ╩╚═╝╚═╝╝╚╝ ╩ ╚═╝═╩╝

        async mounted () {
            try {
                this.$eventHub.$emit('loading', true, 'Aguarde... Carregando configurações...')
                await this.loadChannels()
                await this.loadBalances()
            } catch (e) {
                this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar.')
            } finally {
                this.$eventHub.$emit('loading', false)
            }
        },

        // ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
        // ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
        // ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝

        methods: {

            /**
             * Chama o evento handlePrev do elemento pai
             */
            handlePrev () {
                this.$emit('handlePrev')
            },

            /**
             * Chamando o emit para dar sequência no cadastro
             */
            handleNext () {
                this.$emit('handleNext', this.form)
            },

            /**
             * Carrega o saldo da empresa
             */
            async loadBalances () {
                try {
                    let result = await BalanceServices.balances({ client_id: this.form.client_id })
                    if (result && result.status) {
                        this.balances.list = result.results
                    }
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar o saldo da empresa.')
                }
            },

            /**
             * Carrega a lista de canais
             */
            async loadChannels () {
                try {
                    let result = await ChannelsServices.findAll({ client_id: this.form.client_id })
                    if (result && result.status) {
                        this.options.channels = result.results
                    }
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar os canais.')
                }
            },

            /**
             * Faz uma somatória geral dos contatos informados / grupos / selecionados
             */
            getTotalContacts () {
                return this.form.totalcontacts
            },

            /**
             * Retorna o nome do canal
             */
            getTypeMessage () {
                let type = this.options.channels.find((item) => {
                    return item.services.id === this.form.type_message
                })
                if (type) {
                    return type.services.name
                }
                return '-'
            },

            /**
             * Retornando o centro de custos
             */
            getCoast () {
                let type = this.options.channels.find((item) => {
                    return item.services.id === this.form.type_message
                })
                if (type) {
                    let totalCredits = this.countCredits(this.form.selected_type === 'new_message' ? this.form.message : this.form.default_message_description)
                    return this.priceFormat((type.ch1_tax * this.getTotalContacts()) * totalCredits)
                }
                return '-'
            },

            /**
             * Monta a data de acodo com o tipo (boolean)
             */
            dateMount (date, type = false) {
                if (type) {
                    return moment(this.form.schedule.time).format('HH:mm')
                }
                return moment(this.form.schedule.date).format('DD/MM/YYYY')
            },

            /**
             * Salva os dados criando uma campanha
             */
            async saveForm () {
                try {
                    this.$eventHub.$emit('loading', true, 'Aguarde... Confirmando a campanha...')

                    this.alertConference = false

                    let data = {
                        id_service: this.form.type_message,
                        id_costs: this.form.cost_center,
                        title: this.form.title,
                        origin: this.form.origin,
                        scheluded_to: ''
                    }

                    if (this.form.selected_type === 'new_message') {
                        data.message = this.form.message
                    } else {
                        data.message = this.form.default_message_description
                    }

                    if (this.form.send === 'schedule') {
                        data.scheluded_to = moment(this.form.schedule.date).format('YYYY-MM-DD') + ' ' + moment(this.form.schedule.time).format('HH:mm:ss')
                    }

                    let contactsGroups = this.form.groups.map((item) => {
                        return item.id
                    })

                    let contactsContacts = this.form.contacts.map((item) => {
                        return item.id
                    })

                    let contactsInform = this.form.inform_contacts

                    data.contacts = JSON.stringify({
                        groups: contactsGroups,
                        contacts: contactsContacts,
                        inform_contacts: contactsInform
                    })

                    let tax = this.options.channels.find((item) => {
                        return item.services.id === this.form.type_message
                    })

                    data.channel_code = tax.ch1
                    data.unittax = tax.ch1_tax
                    data.totalContacts = this.getTotalContacts()
                    data.client_id = this.form.client_id || null

                    let result = await CampaignsServices.store(data)

                    if (result && result.status) {
                        this.handleNext()
                        return
                    } else if (result && result.code === 422) {
                        this.alertConference = true
                        for (const key in result.results.errors) {
                            if (result.results.errors.hasOwnProperty(key)) {
                                const element = result.results.errors[key]
                                this.$eventHub.$emit('snackbar', 'error', element.message, false)
                                return
                            }
                        }
                        return
                    }

                    this.alertConference = true

                    throw Error(result.message)
                } catch (e) {
                    this.alertConference = true
                    this.$eventHub.$emit('snackbar', 'error', 'Erro interno, Verifique se a campanha foi criada ou contate o suporte!')
                } finally {
                    this.$eventHub.$emit('loading', false)
                }
            }
        }
    }
</script>

<style lang="stylus" scoped>

    @import './../../../assets/stylus/bootstrap.styl'

    .step-4

        .alert-error
            text-align left
            margin-bottom 20px
            &.on-step4
                margin-top 0px
            .alert-content
                background lighten($red, 80%)
                color #333
                .icon-alert, .text-alert
                    &.text-alert
                        span
                            color darken($red, 10%)

        .item-icon
            text-align center
            margin-bottom 40px
            &:last-child
                margin-bottom 0

            .text-normal
                text-transform uppercase
                font-size 11px
                color #9fa9ae

            .text-detach
                font-size 16px
                font-weight bold
                color $primary

        .item-text

            &:first-child
                margin-top 10px

            .title
                text-transform uppercase
                text-align left
                color $primary
                font-size 11px
                padding 0

            .message
                div
                    white-space pre-line

            .description
                color #9fa9ae
                margin-bottom 20px

                &.background
                    padding 15px
                    background #f5f6f7

                u
                    text-decoration none
                    padding 0 2px
                    &:first-child
                        padding-left 0
                    &::before
                        content "• "
                        color $primary
                    &:hover
                        background $grey
                        color #fff
                        text-decoration none

            .alert-limit-characters
                padding 8px
                border-radius 4px
                font-size 11px
                background lighten($red, 80%)
                color darken($red, 10%)

</style>
